import { gql } from '@apollo/client';
import BASE_ORGANIZATION_ROLE_FRAGMENT from 'graph/fragments/organization-role';
import BASE_USER_FRAGMENT from 'graph/fragments/user';

export default gql`
  query getAdminUserInformation($where: UserWhereInput!) {
    user(where: $where) {
      ...BaseUser
      licenseUsage {
        assignedCount
        trial
        product {
          id
          code
          name
          iconUrl
        }
        productCurriculum {
          id
          code
          name
          iconUrl
        }
      }
      organizationAssociations {
        organizationId
        organization {
          id
          name
          licenseUsage {
            product {
              id
              code
              name
              iconUrl
              type
              family {
                id
                code
              }
            }
            productCurriculum {
              id
              code
              name
              iconUrl
            }
            availableCount
            assignedCount
            siteLicensed
          }
        }
        organizationRoles {
          ...BaseOrganizationRole
        }
      }
    }
  }
  ${BASE_ORGANIZATION_ROLE_FRAGMENT}
  ${BASE_USER_FRAGMENT}
`;
